import { render, staticRenderFns } from "./FinePrint.vue?vue&type=template&id=9b13e45c&scoped=true&"
import script from "./FinePrint.vue?vue&type=script&lang=ts&"
export * from "./FinePrint.vue?vue&type=script&lang=ts&"
import style0 from "./FinePrint.vue?vue&type=style&index=0&id=9b13e45c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b13e45c",
  null
  
)

export default component.exports